export default "__VITE_ASSET__CWbwOW47__"